import type { JournalEntry, JournalLine } from '../types/accounting';
import { sumMoney, moneyEqual } from './currency';

export function validateJournalEntry(entry: Partial<JournalEntry>): boolean {
  if (!entry.date || !entry.journalType || !entry.description || !entry.lines) {
    return false;
  }

  const totalDebit = sumMoney(entry.lines.map(line => line.debit || 0));
  const totalCredit = sumMoney(entry.lines.map(line => line.credit || 0));

  return moneyEqual(totalDebit, totalCredit);
}

export function generateReference(type: string, date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  // Get prefix based on journal type
  const prefix = type.toUpperCase().slice(0, 3);
  
  // Generate a random sequence number (in production this should come from a sequence generator)
  const sequence = String(Math.floor(Math.random() * 999) + 1).padStart(3, '0');
  
  return `${prefix}${year}${month}${day}-${sequence}`;
}

export function formatJournalReference(type: string, date: Date): string {
  return generateReference(type, date);
}